import React, { useEffect, useState } from "react"

import { useHistory, Redirect } from "react-router-dom"
import { TiArrowBack } from "react-icons/ti";
import { IoHome } from "react-icons/io5";
import styles from './payment.module.css';

const PaymentFailed = () => {
    const history = useHistory()
    const [isAllowed, setIsAllowed] = useState(true);

    
    useEffect(() => {
      const flag = sessionStorage.getItem("stripe_cancel_flag");

      if (flag === "true") {
        setIsAllowed(true);
        sessionStorage.removeItem("stripe_cancel_flag");
      } else {
        setIsAllowed(false);
      }
    }, []);

    if (!isAllowed) {
      return <Redirect to="/" />;
    }

    return (
        <div className={styles.webcrumbs}>
            <div className={styles.container}>
                <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: 5 }}>
                    <div className={styles.iconWrapper}>
                        <div className={styles.outerCircle}>
                            <div className={styles.innerCircle} style={{ backgroundColor: "red" }}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-8 w-8 text-white "
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                >
                                    <path d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" />
                                </svg>
                            </div>
                        </div>
                    </div>

                    <h1 className={styles.heading} style={{ color: "red" }}>
                        Payment Failed!
                    </h1>

                    <p className={styles.description} style={{ color: "red" }}>
                        Your transaction could not be processed. Please check your payment details and try again.
                    </p>

                    <div className="flex flex-col sm:flex-row gap-4 mb-6 md:mb-8 w-full justify-center">
                        <button onClick={() => history.push("/")} className={styles.redirectBtn}>
                            <IoHome size={25} color="red" style={{ marginRight: 5 }} />
                            <span style={{ color: "red" }} >Back to Home</span>
                        </button>
                    </div>

                    <div className="w-full">
                        <p style={{ color: "red" }}>
                            Sorry for the inconvenience! Need help?{" "}
                            <a
                                className="text-red-600 hover:text-red-700 hover:underline transition-colors"
                            >
                                Contact our support team
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PaymentFailed